import { ComponentProps } from 'react'
import AssetFilters from './AssetFilters.view'
import { useFilterOptionsFromAssetsList } from './AssetFilters.hook'

export default function AssetFiltersLogic(
  props: Omit<ComponentProps<typeof AssetFilters>, 'filterOptions'>
) {
  const filterOPtions = useFilterOptionsFromAssetsList(props.allAvailableAssets)
  return <AssetFilters {...props} filterOptions={filterOPtions} />
}
